import {fetch, postB, postQ, get} from 'urlconf/index'
import global from '../config/global'
import md5 from 'js-md5'
import {isnull, localGet, localSave} from "../utils/tools";
import version from "vuex/dist/vuex.mjs";
import {postQB} from "../apiconfig";

export default {
  loadVideoChatRoomList(successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/VideoChatRoom/GetRoomList', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  loadMultiChatRoomList(successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return get('api/VideoChatRoom/GetMultiplayerChatRoomList', ['session=' + localGet(global.key.session)], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  joinVideoChatRoomByHostId(hostId, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/VideoChatRoom/JoinRoomByHostId', ['session=' + localGet(global.key.session), 'hostId=' + hostId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  leaveVideoChatRoom(roomId, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQ('api/VideoChatRoom/LeaveRoom', ['session=' + localGet(global.key.session), 'roomId=' + roomId], function (data) {
      successCallback && successCallback(data)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  getVideoChatRoomUserInfo(roomId,userId,successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true){
    return get('api/VideoChatRoom/GetVideoChatRoomUserInfo', ['session=' + localGet(global.key.session), 'roomId=' + roomId,'userId='+userId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj,showLoading,hideLoading)
  },
  getVideoChatRoomAnchorInfo(roomId,userId,successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true){
    return get('api/VideoChatRoom/GetVideoChatRoomAnchorInfo', ['session=' + localGet(global.key.session), 'roomId=' + roomId,'anchorId='+userId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj,showLoading,hideLoading)
  },
  setGiftViewed(title, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/VideoChatRoom/SetGiftViewed', ['session=' + localGet(global.key.session), 'title=' + title], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  },
  sendDMMessage(roomId,content, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/VideoChatRoom/SendTextMsg', ['session=' + localGet(global.key.session), 'roomId=' + roomId,'content='+encodeURIComponent(content)], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  },
  userSendGift(roomId,giftId, successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/VideoChatRoom/UserSendGift', ['session=' + localGet(global.key.session), 'roomId=' + roomId,'giftId='+giftId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  },
  getRoomInfo(roomId, successCallback = null, failCallBack = null, vueObj) {
    return get('api/VideoChatRoom/GetRoomInfo', ['session=' + localGet(global.key.session), 'roomId=' + roomId], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  },

  takeHost(roomId, giftId,successCallback = null, failCallBack = null, vueObj) {
    return postQ('api/VideoChatRoom/UserTakeHost', ['session=' + localGet(global.key.session), 'giftId=' + giftId, 'roomId=' + roomId], function (data) {
      successCallback && successCallback(data,vueObj)
    },  function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, true, true)
  },
  fetchPKTopFans(roomId,hostId,successCallback=null,failCallback=null,vueObj,showLoading=false,hideLoading=false){
    return get('api/VideoChatRoom/GetVideoChatRoomPKTopFanList', ['session=' + localGet(global.key.session),'roomId='+roomId,'hostId='+hostId], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallback&&failCallback(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  reportRoom(roomId,report, successCallback = null, failCallBack = null, vueObj, showLoading = true, hideLoading = true) {
    return postQB('api/VideoChatRoom/ReportRoom', ['session=' + localGet(global.key.session), 'roomId=' + roomId],report, function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, showLoading, hideLoading)
  },
  loadFollowedAnchorsRoom( successCallback = null, failCallBack = null, vueObj){
    return get('api/VideoChatRoom/GetMultiplayerChatRoomFollowingAnchorList', ['session=' + localGet('wdapp-s')], function (data) {
      successCallback && successCallback(data,vueObj)
    }, function (code, msg) {
      failCallBack&&failCallBack(code,msg,vueObj)
    }, '/webApp', vueObj, false, false)
  }
}




// WEBPACK FOOTER //
// ./src/api/live-api.js